import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import {
  CreatePaymentMethodStripeSepaInput,
  CreatePaymentMethodStripeSepaPayload,
} from "@oysterhr/schema"

const PAYMENT_METHODS_COMPANY_CREATE_PAYMENT_METHOD_STRIPE_SEPA = gql`
  mutation PAYMENT_METHODS_COMPANY_CREATE_PAYMENT_METHOD_STRIPE_SEPA(
    $ownerId: ID!
    $setupIntentId: String!
  ) {
    createPaymentMethodStripeSepa(input: { ownerId: $ownerId, setupIntentId: $setupIntentId }) {
      paymentMethod {
        ... on PaymentMethodStripeSepa {
          id
        }
      }
      errors
    }
  }
`
const useCreateSepaPaymentMethod = (
  options?: InjectedOptions<
    { createPaymentMethodStripeSepa: CreatePaymentMethodStripeSepaPayload },
    CreatePaymentMethodStripeSepaInput
  >,
) => useMutation(PAYMENT_METHODS_COMPANY_CREATE_PAYMENT_METHOD_STRIPE_SEPA, options)

export default useCreateSepaPaymentMethod
